/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dental-surface-erosion.reducer';

export const DentalSurfaceErosionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dentalSurfaceErosionEntity = useAppSelector(state => state.dentalSurfaceErosion.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dentalSurfaceErosionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.detail.title">DentalSurfaceErosion</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.id">Id</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.id}</dd>
          <dt>
            <span id="erotionType">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.erotionType">Erotion Type</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.erotionType}</dd>
          <dt>
            <span id="score">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.score">Score</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.score}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.active">Active</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceErosionEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.surface">Surface</Translate>
          </dt>
          <dd>{dentalSurfaceErosionEntity.surface ? dentalSurfaceErosionEntity.surface.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.mouthItem">Mouth Item</Translate>
          </dt>
          <dd>{dentalSurfaceErosionEntity.mouthItem ? dentalSurfaceErosionEntity.mouthItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/dental-surface-erosion" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dental-surface-erosion/${dentalSurfaceErosionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DentalSurfaceErosionDetail;
